
import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Router } from "@angular/router";
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import { environment } from "../../environments/environment";
import { ToastService } from "./toast.service";
import { resolve } from "url";
import { SecurityResponse } from '../_models/security-response.model';
import { BehaviorSubject, Observable } from "rxjs";

export interface User {
  username: string;
  role: 'client' | 'transporter' | 'admin';
}

@Injectable()
  
export class SecurityService {

  private userSubject = new BehaviorSubject<User | null>(null);
  user$: Observable<User | null> = this.userSubject.asObservable();

  constructor(
    private http: Http,
    private router: Router,
    private toast: ToastService
  ) {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    this.loadAuthenticatedUser();
  }

  loadAuthenticatedUser() {
    this.getUserRole().then((roleData) => {
      if (roleData) {
        const role = this.mapRole(roleData);
        const user: User = {
          username: '',
          role: role
        }
        this.userSubject.next(user);
      } else {
        this.userSubject.next(null);
      }
    })
  }

  mapRole(roleData: { is_admin: boolean; is_client: boolean; is_seller: boolean }): 'client' | 'transporter' | 'admin' {
    if (roleData.is_admin) {
      return 'admin';
    } else if (roleData.is_client) {
      return 'client';
    } else if (roleData.is_seller) {
      return 'transporter';
    }
    return null;
  }

  setAuthenticatedUser(user: User) {
    localStorage.setItem('user', JSON.stringify(user));
    this.userSubject.next(user);
  }

  
  /* login */
  login(credentials: { email: string, password: string }) {
    return this.http
      .post(`${environment.API_URL}/login`, credentials)
      .map((res) => {
        const response = res.json();
        this.setToken(response.token);
        
        localStorage.setItem('navigation', response.navigation)
        // Toast Notification
        this.toast.success("Vous êtes connecté.", false, "Connexion");
        return response;
      });
  }
  //verifyToken
  verifyToken(): Observable<SecurityResponse> {
    const token = this.getToken();
    if (!token) {
      return Observable.of(null);
    }

    return this.http.post(`${environment.API_URL}/verifyToken`, {
      token: token,
    }).map((res: Response) => res.json() as SecurityResponse)
      .catch(() => Observable.of(null));
  };

  getToken(): string | null {
    return localStorage.getItem("token");

  }
  setToken(token: string): void {
    localStorage.setItem("token", token);
  }

  clearToken(): void {
    localStorage.removeItem("token");
  }

  getUserRole(): Promise <{is_admin: boolean, is_client: boolean, is_seller: boolean} | null> {
    return new Promise((resolve, reject) => {
      this.verifyToken().subscribe((response) => {
        let result: {is_admin: boolean, is_client: boolean, is_seller: boolean} | null = null;
        if (response && response.user) {
          let user = response.user;
          result = {
            is_admin: user.is_admin,
            is_client: !user.is_admin && user.is_client,
            is_seller: !user.is_admin && user.is_seller
          };
        } else {
          result = null
        }

        return resolve(result);
      });
    });
  }
  
  // check if logged in user is admin 
  isAdmin() {
    return new Promise((resolve, reject) => {
      this.verifyToken().subscribe((response) => {
        resolve(response.user.is_admin == true);
      });
    });
  }
  /*
  // check if logged in user is client 
  isClient() {
    return new Promise((resolve, reject) => {
      this.verifyToken().subscribe((response) => {
        resolve(response.user.is_admin == false && response.user.is_client == true);
      });
    });
  }
  // check if logged in user is Seller (transporter)
  isSeller() {
    return new Promise((resolve, reject) => {
      this.verifyToken().subscribe((response) => {
        resolve(response.user.is_admin == false && response.user.is_seller == true);
      });
    });
  }
  */
  /* current logged in user infos */
  async userInfos() {
    return new Promise((resolve, reject) => {
      this.verifyToken().subscribe((response) => {
        resolve(response.user);
      }, (error) => {
        reject(error)
      });
    });
  }


  logout() {
    //delete local storage key
    localStorage.removeItem("navigation");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    this.userSubject.next(null);

    localStorage.clear();
    sessionStorage.clear();
    this.clearToken();
    this.router.navigateByUrl("login");
    this.toast.error("Vous avez été déconnecté.", false, "Déconnexion");
  }

  
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/security.service.ts